import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {TabBar as RmwcTabBar} from '@rmwc/tabs'
import '@rmwc/tabs/styles'

const StyledRmwcTabBar = styled(RmwcTabBar)``

const TabBar = ({children, activeTabIndex, onActivate, ...otherProps}) => (
  <StyledRmwcTabBar activeTabIndex={activeTabIndex} onActivate={onActivate} {...otherProps}>
    {children}
  </StyledRmwcTabBar>
)

TabBar.propTypes = {
  children: PropTypes.any,
  activeTabIndex: PropTypes.number,
  onActivate: PropTypes.func
}

export {TabBar}
